<script>
import client from '@sanityConfig'
import imageUrlBuilder from '@sanity/image-url'
import { mapGetters, mapState } from 'vuex'
import { breakpointsMixin } from '../../mixins/breakpointsMixin'
import Translate from '../translate'
import { dateTimeFormatters } from '@src/utils/date-formatters'
const { dateIsAfterOfCurrentDate, dateIsBeforeOfCurrentDate } = dateTimeFormatters()

const builder = imageUrlBuilder(client)

export default {
  data () {
    return {
      height: 'unset',
      viewActions: false
    }
  },
  components: { Translate },
  mixins: [breakpointsMixin],
  computed: {
    ...mapState(['user', 'home', 'settings', 'challenges', 'challengePage']),
    ...mapGetters(['primaryColor', 'loggedIn']),
    appIcon () {
      return (
        this.settings && this.settings.icon && builder.image(this.settings.icon)
      )
    },
    siteName () {
      return this.settings && this.settings.siteName && this.settings.siteName
    },
    userAvatar () {
      return this.user &&
        this.user &&
        this.user.profile &&
        this.user.profile.image &&
        this.user.profile.image !== ''
        ? this.user.profile.image
        : require('@assets/placeholder-avatar.png')
    },
    isProfile () {
      return this.$route.fullPath.match(/^.*\b(profile)\b.*$/gm) && this.$route.fullPath.match(/^.*\b(profile)\b.*$/gm).length > 0
    },
    isTransparent () {
      return !this.isProfile
    }
  },
  methods: {
    async signOut () {
      await this.$store.commit('setUser', null)
      await this.$store.commit('setCouponData', {})
      await this.$store.commit('setSelectedOrder', {})
      await localStorage.removeItem('pcc-user')
      // eslint-disable-line
      // await FB.getLoginStatus(function(response) { // eslint-disable-line
      //   // eslint-disable-line
      //   if (response && response.status === 'connected') {
      //     FB.logout(function(response) { // eslint-disable-line
      //       // eslint-disable-line
      //       document.location.reload()
      //     })
      //   }
      // })
      window.Leanplum.stop()
      this.$router.push('/').catch((err) => {}) // eslint-disable-line
      this.viewActions = false
    },
    isPromoActive () {
      if (
        this.settings.banner &&
        this.settings.banner.bannerTitle &&
        this.settings.banner.promoStartDate &&
        this.settings.banner.promoEndDate &&
        dateIsAfterOfCurrentDate(this.settings.banner.promoStartDate) &&
        dateIsBeforeOfCurrentDate(this.settings.banner.promoEndDate)
      ) {
        return true
      } else return false
    },
    urlFor (source) {
      return builder.image(source)
    },
    openLogin () {
      this.$bvModal.show('modal-login')
      this.viewActions = false
    },
    openSignup () {
      this.$bvModal.show('modal-signup')
      this.viewActions = false
    },
    openNewSignup () {
      this.$bvModal.show('new-modal-signup')
      this.viewActions = false
    },
    openEitherSignupModals () {
      if (this.settings?.newCheckout?.checkoutImage) {
        this.openNewSignup()
        this.$store.commit('setAuthModalType', 'signup')
      } else {
        this.openSignup()
      }
    },
    openEitherLoginModals () {
      if (this.settings?.newCheckout?.checkoutImage) {
        this.openNewSignup()
        this.$store.commit('setAuthModalType', 'login')
      } else {
        this.openLogin()
      }
    },
    toProfile () {
      this.$router.push({ name: 'Info' }).catch(() => {})
      this.viewActions = false
    },
    toHome () {
      if (this.$route.name !== 'Home') {
        this.$router.push({ name: 'Home' })
        this.viewActions = false
      }
    },
    clickedOutside () {
      this.viewActions = false
    }
  }
}
</script>

<template>
  <div v-if="settings" @mouseleave="clickedOutside">
    <div>
      <b-navbar toggleable="lg" :class="{ isTransparent: isTransparent }">
        <div class="left-nav">
          <img v-if="appIcon" class="app-icon" :src="appIcon" @click="toHome" alt="app icon"/>
          <div>
            <span class="home" @click="toHome">{{siteName}}</span>
          </div>
        </div>
        <div v-if="!isDesktopView" class="actions mobile">
          <span v-if="$route.name !== 'Challenge'" @click="viewActions = !viewActions"
            ><BaseIcon class="bars" name="bars"
          /></span>
          <transition name="slide-fade">
            <div v-if="!loggedIn && viewActions" class="right-nav">
              <BaseButton v-if="$route.name !== 'Challenge'" type="button" class="btn-clear" @click="openEitherLoginModals"
                ><Translate directive="nav.login"/></BaseButton
              >
              <BaseButton v-if="$route.name !== 'Challenge'" type="button" class="btn-sigup" @click="openEitherSignupModals"
                ><Translate directive="nav.signup"/></BaseButton
              >
            </div>
            <div
              v-if="loggedIn && viewActions"
              :class="['right-nav', { isTransparent: isTransparent }]"
            >
              <BaseButton
                type="button"
                :class="['btn-clear profile', { isTransparent: isTransparent }]"
                @click="toProfile"
                ><Translate directive="nav.profile"/></BaseButton
              >
              <BaseButton
                v-if="!isProfile"
                type="button"
                :class="['btn-clear logout']"
                @click="signOut"
                ><Translate directive="logout"/></BaseButton
              >
            </div>
          </transition>
        </div>
        <div v-if="!loggedIn && isDesktopView" class="right-nav">
          <BaseButton v-if="$route.name !== 'Challenge'" type="button" class="btn-clear btn-login" @click="openEitherLoginModals"
            ><Translate directive="nav.login"/></BaseButton
          >
          <BaseButton v-if="$route.name !== 'Challenge'" type="button" class="btn-sigup" @click="openEitherSignupModals"
            ><Translate directive="nav.signup"/></BaseButton
          >
        </div>
        <div
          v-if="loggedIn && isDesktopView"
          :class="['right-nav', { isTransparent: isTransparent }]"
        >
          <BaseButton
            v-if="!isProfile"
            type="button"
            :class="['btn-clear profile', { isTransparent: isTransparent }]"
            @click="toProfile"
            ><span>{{ user.profile.name }}</span></BaseButton
          >
          <img class="user-avatar" :src="userAvatar" />
        </div>
      </b-navbar>
    </div>
    <div
      v-if="isPromoActive()"
      :style="{
        '--background-color': `${
          settings.banner ? settings.banner.bannerBGColor.hex : 'white'
        }`,
        '--title-color': `${
          settings.banner ? settings.banner.bannerTitleColor.hex : 'white'
        }`,
      }"
      class="promo"
    >
      <p class="p">{{ settings.banner ? settings.banner.bannerTitle : '' }}</p>
      <b-button
        class="banner-button"
        :style="{
          '--text-color': `${
            settings.banner ? settings.banner.bannerBGColor.hex : 'white'
          }`,
          '--background-color': `${
            settings.banner ? settings.banner.bannerTitleColor.hex : 'white'
          }`,
        }"
        href="#"
        ><p>{{
          settings.banner ? settings.banner.bannerButtonText : 'Go'
        }}</p></b-button
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

nav {
  color: #fff !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  z-index: 5;
  flex-wrap: nowrap;
  padding-right: 16px;
  .left-nav {
    margin-left: 5%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: flex-start;
    div {
      flex-wrap: wrap;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-left: 1.6rem;
      .btn-clear {
        font-family: $base-font-family;
        font-style: normal;
        font-weight: 800;
        @include calc-font-size(1.3);
        letter-spacing: -0.161905px;
        color: #ffffff;
        text-transform: uppercase;
        padding: 1.1rem 1.5rem;
        padding-right: 0.5rem;
      }
      .home {
        word-break: break-all;
        padding-right: 0.5rem;
        text-align: start;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
      }
      span {
        text-align: start;
        word-break: break-all;
        font-family: $base-font-family;
        font-style: normal;
        font-weight: 800;
        @include calc-font-size(1.4);
        letter-spacing: -0.161905px;
        color: #ffffff;
        text-align: center;
        vertical-align: middle;
        @media screen and (max-width: 400px) {
          font-size: 1.1rem;
        }
      }
    }
    .app-icon {
      position: relative;
      width: 3.5rem;
      height: 3.5rem;
      background-color: transparent;
      border-radius: 1rem;
      object-fit: cover;
      border: unset;
      cursor: pointer;
    }
  }
  .right-nav {
    margin-right: 2.5%;
    .user-avatar {
      width: 2.5rem;
      height: 2.5rem;
      border-radius: 50%;
      transition: transform 300ms;
      transition-timing-function: ease-out;
      // Save for later
      //  &:hover {
      //    cursor: pointer;
      //    transform: scale(1.05);
      //  }
    }
    .btn-clear {
      font-style: normal;
      font-weight: 600;
      color: #ffffff;
      @include calc-font-size(0.9);
      line-height: 23px;
      margin-right: 20px;
      &:hover {
        color: darken(#ffffff, 5);
      }
      &.profile {
        margin-right: 1.5rem;
        &:not(.isTransparent) {
          color: black;
        }
      }
      &.logout {
        padding: 1.1rem 2.4rem;
        padding-right: 0rem;
      }
    }
  }
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    background-image: linear-gradient(rgba(black, 0.6), rgba(black, 0));
    z-index: -1;
  }
  &:not(.isTransparent) {
    position: sticky;
    background-color: white;
    border-bottom: 1px rgba(136, 136, 136, 0.4) solid;
    color: black;
    .btn-clear {
      color: black;
      &:hover {
        opacity: 0.6;
        color: lighten(black, 3);
      }
    }
    .left-nav {
      div {
        .btn-clear {
          color: black;
        }
        span {
          color: black;
        }
      }
    }
    .bars {
      color: black;
      cursor: pointer;
      &:hover {
        color: darken(black, 20);
      }
    }
    &::after {
      all: unset;
    }
  }
  .actions {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    align-self: flex-start;
    margin-top: 0.7rem;
    span {
      justify-self: flex-start;
      outline: none;
    }
    .right-nav {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
      .button {
        white-space: nowrap;
      }
      .profile {
        margin-right: 1.5rem;
        padding-right: 0rem;
      }
      .logout {
        padding-right: 0rem;
        padding-top: 0.5rem;
        margin-right: 1.2rem;
      }
    }
    .slide-fade-enter-active {
      transition: all 0.7s ease;
    }
    .slide-fade-leave-active {
      transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
    }
    .slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
      transform: translateY(-10px);
      opacity: 0;
    }
  }
  .bars {
    width: 2rem;
    height: 2rem;
    // margin-right: 2rem;
    color: white;
    transition: color 300ms;
    transition-timing-function: ease-out;
    cursor: pointer;
    &:hover {
      color: darken(white, 20);
    }
  }
}
.promo {
  padding: 0;
  display: flex;
  width: 100%;
  background-color: var(--background-color);
  color: var(--title-color);
  right: 10%;
  left: 10%;
  min-height: 40px;
  border-radius: 0px 0px 0px 0px;
  font-family: 'Montserrat', sans-serif;
  letter-spacing: 2px;
  padding-left: 20px;
  padding-right: 0px;
  text-align: center;
  z-index: 1;
  word-break: initial;
  @media (max-width: 768px) {
    font-size: small;
  }
}
.banner-button {
  white-space: nowrap;
  margin-top: 0px;
  display: flex;
  border: none;
  letter-spacing: 2px;
  min-height: 40px;
  border-radius: 0px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  background-color: var(--background-color);
  text-transform: uppercase;
  color: var(--text-color);
  min-height: 40px;
  -webkit-font-smoothing: antialiased;
  margin-inline-start: auto;
  word-break: initial;
  @media (max-width: 768px) {
    font-size: small;
  }
  &:hover {
    background-color: var(--text-color);
    color: var(--background-color);
  }
  p {
    margin: 0;
    align-self: center;
    margin-bottom: 0;
  }
}
.p {
  padding: 20px;
  margin-top: 0;
  margin-bottom: 0;
  align-self: center;
  text-align: left;
  margin-left: auto;
  word-break: break-word;
}
</style>
